import { SortingDirection } from '@doxyme/ui';
import { UPDATE_LOCATIONS_SORTING, SET_DEFAULT_LOCATIONS_SORTING, } from '../constants/action-types';
import { LocationTableFields } from '../components/locations-table';
export const DEFAULT_STATE = {
    direction: SortingDirection.ASC,
    field: LocationTableFields.NAME,
};
// eslint-disable-next-line @typescript-eslint/default-param-last
export const sorting = (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case UPDATE_LOCATIONS_SORTING:
            return { ...action.payload };
        case SET_DEFAULT_LOCATIONS_SORTING:
            return { ...DEFAULT_STATE };
        default:
            return state;
    }
};
